import { Record } from 'immutable'

export class TransportCondition extends Record({
    id: undefined,
    code: undefined,
    name: undefined,
}) {}
